<!-- 专家修改 -->
<template>
  <div>
    <template v-if="emEdit.length">
      <div v-for="(emItem, index) in emEdit"
           :key="index">
        <expert @on-detail="handleDetail"
                :data="emItem.expertEdit"
                @on-feedback="handleFeedback"
                type="CV"></expert>
      </div>
    </template>
    <zlr-empty v-else
               style="margin-top:48px;"></zlr-empty>
    <!-- 查看详情 -->
    <expert-detail ref="expertDetail"></expert-detail>
    <!-- 反馈 -->
    <expert-feedback ref="expertFeedback"
                     @on-success="getExpertCv"></expert-feedback>
  </div>
</template>

<script>
// API
import { getExpertCv } from '@/api/expert'
// components
import Expert from './components/expert'
import ExpertDetail from './components/expert-detail'
import ExpertFeedback from './components/expert-feedback'
import ZlrEmpty from '_c/empty/empty'
export default {
  name: '',
  components: {
    Expert,
    ExpertDetail,
    ExpertFeedback,
    ZlrEmpty
  },
  data () {
    return {
      cvId: this.$route.params.cvId,
      emEdit: []
    }
  },
  computed: {},
  mounted () {
    this.getExpertCv()
  },
  methods: {
    // 获取CV
    getExpertCv () {
      getExpertCv({
        billId: this.cvId
      }).then(res => {
        let data = (res.data && res.data.model) || {}
        let emEdit = data.emEdit || []
        this.emEdit = emEdit.filter(item => item.expertEdit && item.expertEdit.length) || []
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    handleDetail (data) {
      this.$refs['expertDetail'].show(data)
    },
    handleFeedback (data) {
      this.$refs['expertFeedback'].show(data)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
